// Coordinates Excel's responsive sticky header and rotating trust messages.
(function () {
  var desktopLayoutQuery = window.matchMedia('(min-width: 1024px)');
  var desktopHoverQuery = window.matchMedia(
    '(min-width: 1024px) and (hover: hover) and (pointer: fine)'
  );
  var desktopMenuStates = new WeakMap();
  var desktopMenuStateList = [];
  var boundMegaMenus = new WeakSet();
  var boundMobileNavs = new WeakSet();
  var mobileNavStates = new WeakMap();
  var stickyFrame = null;
  var condensedClass = 'excel-header--condensed';
  var mobileScrolledClass = 'excel-header--mobile-scrolled';
  var collapseThreshold = 96;
  var expandThreshold = 24;
  var mobileCollapseThreshold = 40;
  var mobileExpandThreshold = 8;
  var trustRotationDelay = 4800;
  var desktopMenuIntentDelay = 70;
  var desktopMenuExitDelay = 150;
  var desktopMenuOpenDuration = 160;
  var desktopMenuSwitchDuration = 170;
  var desktopMenuCloseDuration = 100;
  var desktopMenuTransitionFallback = 220;
  var mobilePanelTransitionFallback = 340;

  function directChild(element, selector) {
    if (!element) return null;

    for (var i = 0; i < element.children.length; i++) {
      if (element.children[i].matches(selector)) {
        return element.children[i];
      }
    }

    return null;
  }

  function clearDesktopMenuTimer(state, key) {
    if (!state || state[key] === null) return;

    window.clearTimeout(state[key]);
    state[key] = null;
  }

  function clearDesktopMenuFrame(state) {
    if (!state || state.frame === null) return;

    window.cancelAnimationFrame(state.frame);
    state.frame = null;
  }

  function setDesktopMenuPhase(state, phase) {
    state.phase = phase;
    state.navigation.setAttribute('data-excel-menu-phase', phase);
  }

  function setDesktopMenuInput(state, input) {
    state.navigation.setAttribute('data-excel-menu-input', input);
  }

  function clearDesktopPanelTransition(part) {
    if (part && part.transitionCleanup) {
      part.transitionCleanup();
    }
  }

  function prepareDesktopPanelTransition(part) {
    if (!part || !part.transitionElements.length) return;

    // Resolve the starting opacity after a closed <details> becomes visible so
    // the next-frame state change always produces a transition.
    part.transitionElements.forEach(function (element) {
      var styles = window.getComputedStyle(element);
      styles.opacity;
      styles.transform;
    });
  }

  function afterDesktopPanelTransition(state, part, revision, duration, callback) {
    if (!part || !part.transitionElements.length) {
      callback();
      return;
    }

    clearDesktopPanelTransition(part);

    var finished = false;
    var fallbackTimer = null;
    var finish = function () {
      if (finished) return;
      finished = true;
      cleanup();

      if (state.revision === revision) callback();
    };
    var transitionHandler = function (event) {
      if (part.transitionElements.indexOf(event.target) === -1) return;
      if (event.propertyName !== 'opacity' && event.propertyName !== 'transform') return;
      finish();
    };
    var cleanup = function () {
      part.transitionElements.forEach(function (element) {
        element.removeEventListener('transitionend', transitionHandler);
        element.removeEventListener('transitioncancel', transitionHandler);
      });
      if (fallbackTimer !== null) window.clearTimeout(fallbackTimer);
      fallbackTimer = null;
      part.transitionCleanup = null;
    };

    part.transitionCleanup = cleanup;
    part.transitionElements.forEach(function (element) {
      element.addEventListener('transitionend', transitionHandler);
      element.addEventListener('transitioncancel', transitionHandler);
    });
    fallbackTimer = window.setTimeout(finish, Math.max(duration + 50, desktopMenuTransitionFallback));
  }

  function setDesktopPartActive(part, isActive) {
    if (!part) return;

    if (isActive) {
      part.item.setAttribute('data-excel-menu-active', '');
      part.summary.setAttribute('data-excel-menu-active', '');
      part.summary.setAttribute('aria-expanded', 'true');
      part.panel.setAttribute('aria-hidden', 'false');
      part.panel.removeAttribute('inert');
    } else {
      part.item.removeAttribute('data-excel-menu-active');
      part.summary.removeAttribute('data-excel-menu-active');
      part.summary.setAttribute('aria-expanded', 'false');
      part.panel.setAttribute('aria-hidden', 'true');
      part.panel.setAttribute('inert', '');
    }
  }

  function closeDesktopPartImmediately(part) {
    if (!part) return;

    clearDesktopPanelTransition(part);
    setDesktopPartActive(part, false);
    part.panel.setAttribute('data-excel-menu-state', 'closed');
    part.panel.removeAttribute('data-excel-menu-direction');
    part.panel.removeAttribute('data-excel-menu-input');
    part.details.removeAttribute('open');
  }

  function showDesktopMenuDimmer(state) {
    if (!state.dimmer) return;

    if (state.dimmerTimer !== null) {
      window.clearTimeout(state.dimmerTimer);
      state.dimmerTimer = null;
    }

    state.dimmer.classList.add('is-mounted');
    window.requestAnimationFrame(function () {
      if (state.activePart) state.dimmer.classList.add('is-visible');
    });
  }

  function hideDesktopMenuDimmer(state, immediate) {
    if (!state.dimmer) return;

    if (state.dimmerTimer !== null) {
      window.clearTimeout(state.dimmerTimer);
      state.dimmerTimer = null;
    }

    state.dimmer.classList.remove('is-visible');

    if (immediate) {
      state.dimmer.classList.remove('is-mounted');
      return;
    }

    var revision = state.revision;
    state.dimmerTimer = window.setTimeout(function () {
      state.dimmerTimer = null;
      if (state.revision !== revision || state.activePart) return;
      state.dimmer.classList.remove('is-mounted');
    }, desktopMenuCloseDuration + 50);
  }

  function primeDesktopMenuImages(part) {
    if (!part || part.imagesPrimed) return;

    part.imagesPrimed = true;
    part.panel.querySelectorAll('img').forEach(function (image) {
      var source = image.currentSrc || image.getAttribute('src');
      var decodeImage = image;

      if (!image.complete && source) {
        decodeImage = new Image();
        decodeImage.src = source;
      }

      if (typeof decodeImage.decode === 'function') {
        decodeImage.decode().catch(function () {
          // Image decoding is an optional warm-up and never blocks navigation.
        });
      }
    });
  }

  function closeStaleDesktopParts(state, exceptions) {
    state.parts.forEach(function (part) {
      if (exceptions.indexOf(part) !== -1) return;
      closeDesktopPartImmediately(part);
    });
  }

  function openDesktopMenuCold(state, part, input) {
    state.revision += 1;
    var revision = state.revision;

    clearDesktopMenuFrame(state);
    closeStaleDesktopParts(state, [part]);
    state.activePart = part;
    state.desiredPart = part;
    setDesktopMenuInput(state, input);
    setDesktopPartActive(part, true);
    part.details.setAttribute('open', '');
    part.panel.setAttribute('data-excel-menu-input', input);
    showDesktopMenuDimmer(state);

    if (input === 'keyboard') {
      part.panel.setAttribute('data-excel-menu-state', 'open');
      setDesktopMenuPhase(state, 'open');
      return;
    }

    setDesktopMenuPhase(state, 'opening');
    part.panel.setAttribute('data-excel-menu-state', 'opening');
    prepareDesktopPanelTransition(part);
    state.frame = window.requestAnimationFrame(function () {
      state.frame = null;
      if (state.revision !== revision || state.activePart !== part) return;

      part.panel.setAttribute('data-excel-menu-state', 'opened');
      afterDesktopPanelTransition(
        state,
        part,
        revision,
        desktopMenuOpenDuration,
        function () {
          part.panel.setAttribute('data-excel-menu-state', 'open');
          setDesktopMenuPhase(state, 'open');
        }
      );
    });
  }

  function switchDesktopMenu(state, nextPart, input) {
    var previousPart = state.activePart;
    if (!previousPart || previousPart === nextPart) return;

    state.revision += 1;
    var revision = state.revision;
    var direction = nextPart.index > previousPart.index ? 'forward' : 'backward';

    clearDesktopMenuFrame(state);
    clearDesktopPanelTransition(previousPart);
    clearDesktopPanelTransition(nextPart);
    closeStaleDesktopParts(state, [previousPart, nextPart]);

    state.activePart = nextPart;
    state.desiredPart = nextPart;
    setDesktopMenuInput(state, input);
    setDesktopMenuPhase(state, 'switching');

    setDesktopPartActive(previousPart, false);
    setDesktopPartActive(nextPart, true);
    nextPart.details.setAttribute('open', '');
    previousPart.panel.setAttribute('data-excel-menu-direction', direction);
    nextPart.panel.setAttribute('data-excel-menu-direction', direction);
    nextPart.panel.setAttribute('data-excel-menu-input', input);

    if (input === 'keyboard') {
      closeDesktopPartImmediately(previousPart);
      nextPart.panel.setAttribute('data-excel-menu-state', 'open');
      setDesktopMenuPhase(state, 'open');
      return;
    }

    nextPart.panel.setAttribute('data-excel-menu-state', 'entering');
    prepareDesktopPanelTransition(nextPart);
    state.frame = window.requestAnimationFrame(function () {
      state.frame = null;
      if (state.revision !== revision || state.activePart !== nextPart) return;

      previousPart.panel.setAttribute('data-excel-menu-state', 'leaving');
      nextPart.panel.setAttribute('data-excel-menu-state', 'open');

      afterDesktopPanelTransition(
        state,
        previousPart,
        revision,
        desktopMenuSwitchDuration,
        function () {
          closeDesktopPartImmediately(previousPart);
          nextPart.panel.removeAttribute('data-excel-menu-direction');
          setDesktopMenuPhase(state, 'open');
        }
      );
    });
  }

  function reopenDesktopMenuFromClose(state, part, input) {
    state.revision += 1;
    var revision = state.revision;

    clearDesktopMenuFrame(state);
    clearDesktopPanelTransition(part);
    state.activePart = part;
    state.closingPart = null;
    state.closingRects = null;
    state.desiredPart = part;
    setDesktopMenuInput(state, input);
    setDesktopPartActive(part, true);
    part.details.setAttribute('open', '');
    part.panel.setAttribute('data-excel-menu-input', input);
    showDesktopMenuDimmer(state);

    if (input === 'keyboard') {
      part.panel.setAttribute('data-excel-menu-state', 'open');
      setDesktopMenuPhase(state, 'open');
      return;
    }

    // Capture the panel at its current point in the close transition, then
    // reverse toward open without resetting to the cold-open start frame.
    setDesktopMenuPhase(state, 'opening');
    prepareDesktopPanelTransition(part);
    part.panel.setAttribute('data-excel-menu-state', 'opened');
    afterDesktopPanelTransition(
      state,
      part,
      revision,
      desktopMenuOpenDuration,
      function () {
        part.panel.setAttribute('data-excel-menu-state', 'open');
        setDesktopMenuPhase(state, 'open');
      }
    );
  }

  function openDesktopMenu(state, part, input) {
    if (!state || !part || !desktopLayoutQuery.matches) return;

    clearDesktopMenuTimer(state, 'intentTimer');
    clearDesktopMenuTimer(state, 'closeTimer');
    primeDesktopMenuImages(part);

    if (state.closingPart === part) {
      reopenDesktopMenuFromClose(state, part, input);
      return;
    }

    if (state.closingPart) {
      // A different sibling hovered during close still has a visible outgoing
      // frame. Reuse it as the switch source so the new target wins at once.
      state.activePart = state.closingPart;
      state.closingPart = null;
      state.closingRects = null;
      showDesktopMenuDimmer(state);
    }

    if (state.activePart === part) {
      state.desiredPart = part;
      return;
    }

    if (state.activePart) {
      switchDesktopMenu(state, part, input);
    } else {
      openDesktopMenuCold(state, part, input);
    }
  }

  function requestDesktopMenuOpen(state, part) {
    if (!desktopHoverQuery.matches || !state || !part) return;

    state.desiredPart = part;
    clearDesktopMenuTimer(state, 'closeTimer');
    primeDesktopMenuImages(part);

    if (state.activePart || state.closingPart) {
      openDesktopMenu(state, part, 'pointer');
      return;
    }

    clearDesktopMenuTimer(state, 'intentTimer');
    state.intentTimer = window.setTimeout(function () {
      state.intentTimer = null;
      if (state.desiredPart !== part || !part.item.matches(':hover')) return;
      openDesktopMenu(state, part, 'pointer');
    }, desktopMenuIntentDelay);
  }

  function closeDesktopMenu(state, options) {
    if (!state) return;

    options = options || {};
    clearDesktopMenuTimer(state, 'intentTimer');
    clearDesktopMenuTimer(state, 'closeTimer');
    clearDesktopMenuFrame(state);
    state.desiredPart = null;

    if (!state.activePart) {
      if (state.closingPart) {
        if (options.immediate) {
          state.revision += 1;
          closeDesktopPartImmediately(state.closingPart);
          state.closingPart = null;
          state.closingRects = null;
          setDesktopMenuPhase(state, 'closed');
          hideDesktopMenuDimmer(state, true);
        }
        return;
      }

      setDesktopMenuPhase(state, 'closed');
      hideDesktopMenuDimmer(state, true);
      return;
    }

    state.revision += 1;
    var revision = state.revision;
    var part = state.activePart;
    var immediate = !!options.immediate || options.input === 'keyboard';

    state.activePart = null;
    state.closingPart = part;
    state.closingRects = [part.item, part.panel].map(function (element) {
      var rect = element.getBoundingClientRect();
      return {
        bottom: rect.bottom,
        left: rect.left,
        right: rect.right,
        top: rect.top,
      };
    });
    setDesktopPartActive(part, false);
    closeStaleDesktopParts(state, [part]);
    setDesktopMenuInput(state, options.input || 'pointer');

    if (immediate) {
      closeDesktopPartImmediately(part);
      state.closingPart = null;
      state.closingRects = null;
      setDesktopMenuPhase(state, 'closed');
      hideDesktopMenuDimmer(state, true);
      if (options.restoreFocus) part.summary.focus();
      return;
    }

    setDesktopMenuPhase(state, 'closing');
    part.panel.setAttribute('data-excel-menu-state', 'closing');
    hideDesktopMenuDimmer(state, false);
    afterDesktopPanelTransition(
      state,
      part,
      revision,
      desktopMenuCloseDuration,
      function () {
        closeDesktopPartImmediately(part);
        state.closingPart = null;
        state.closingRects = null;
        setDesktopMenuPhase(state, 'closed');
      }
    );
  }

  function scheduleDesktopMenuClose(state) {
    if (!state) return;

    clearDesktopMenuTimer(state, 'intentTimer');
    clearDesktopMenuTimer(state, 'closeTimer');
    state.desiredPart = null;
    state.closeTimer = window.setTimeout(function () {
      state.closeTimer = null;
      var focusedElement = document.activeElement;
      if (state.activePart && state.activePart.panel.contains(focusedElement) && focusedElement.closest('form')) return;
      closeDesktopMenu(state);
    }, desktopMenuExitDelay);
  }

  function desktopPartForElement(state, element) {
    if (!element) return null;

    return state.parts.find(function (part) {
      return part.item === element || part.summary === element;
    }) || null;
  }

  function pointerIsWithinRect(event, rect) {
    if (!event || !rect) return false;

    return (
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    );
  }

  function bindDesktopMenuEvent(state, target, eventName, listener, options) {
    target.addEventListener(eventName, listener, options);
    state.events.push({
      target: target,
      eventName: eventName,
      listener: listener,
      options: options,
    });
  }

  function createDesktopMenuState(navigation) {
    var items = Array.prototype.slice.call(
      navigation.querySelectorAll('.navmenu-depth-1 > [data-excel-desktop-menu-parent]')
    );
    if (!items.length) return null;

    var state = {
      activePart: null,
      closeTimer: null,
      closingPart: null,
      closingRects: null,
      desiredPart: null,
      dimmer: document.querySelector('[data-site-main-dimmer]'),
      dimmerTimer: null,
      events: [],
      frame: null,
      intentTimer: null,
      navigation: navigation,
      parts: [],
      phase: 'closed',
      revision: 0,
    };

    state.parts = items.map(function (item, index) {
      var details = directChild(item, 'details[data-navmenu-details]');
      var summary = directChild(details, 'summary.navmenu-link-parent');
      var panel = directChild(details, '[data-navmenu-submenu]');
      if (!details || !summary || !panel) return null;

      var configuredIndex = parseInt(item.getAttribute('data-excel-desktop-menu-index'), 10);
      var motionElement = directChild(panel, '.navmenu-meganav-wrapper') || panel;
      var part = {
        details: details,
        imagesPrimed: false,
        index: Number.isNaN(configuredIndex) ? index : configuredIndex,
        item: item,
        motionElement: motionElement,
        panel: panel,
        summary: summary,
        transitionElements: motionElement === panel ? [panel] : [panel, motionElement],
        transitionCleanup: null,
      };

      closeDesktopPartImmediately(part);
      return part;
    }).filter(Boolean);

    if (!state.parts.length) return null;

    navigation.setAttribute('data-excel-menu-controller', 'excel');
    navigation.setAttribute('data-excel-menu-phase', 'closed');
    if (state.dimmer) state.dimmer.classList.add('excel-menu-dimmer');

    bindDesktopMenuEvent(state, navigation, 'pointerover', function (event) {
      if (!desktopHoverQuery.matches) return;
      if (event.pointerType && event.pointerType !== 'mouse') return;

      var item = event.target.closest('[data-excel-desktop-menu-parent]');
      if (item && navigation.contains(item)) {
        requestDesktopMenuOpen(state, desktopPartForElement(state, item));
        return;
      }

      var topLevelItem = event.target.closest('.navmenu-depth-1 > .navmenu-item');
      if (topLevelItem && navigation.contains(topLevelItem) && state.activePart) {
        closeDesktopMenu(state);
      }
    });

    bindDesktopMenuEvent(state, navigation, 'pointerenter', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      clearDesktopMenuTimer(state, 'closeTimer');
    });

    bindDesktopMenuEvent(state, navigation, 'pointerleave', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      if (!desktopHoverQuery.matches) return;
      scheduleDesktopMenuClose(state);
    });

    // A closing panel is inert and does not participate in hit testing. Track
    // its still-visible geometry briefly so returning through the panel area
    // can reverse the close instead of falling through to the page dimmer.
    bindDesktopMenuEvent(state, document, 'pointermove', function (event) {
      if (!state.closingPart || !desktopHoverQuery.matches) return;
      if (event.pointerType && event.pointerType !== 'mouse') return;

      var closingPart = state.closingPart;
      if (state.closingRects && state.closingRects.some(function (rect) {
        return pointerIsWithinRect(event, rect);
      })) {
        openDesktopMenu(state, closingPart, 'pointer');
      }
    }, { passive: true });

    bindDesktopMenuEvent(state, navigation, 'click', function (event) {
      var summary = event.target.closest('[data-excel-desktop-menu-trigger]');
      if (!summary || !navigation.contains(summary)) return;

      var part = desktopPartForElement(state, summary);
      if (!part) return;

      event.preventDefault();
      event.stopPropagation();

      if (state.activePart === part && part.summary.getAttribute('aria-expanded') === 'true') {
        var destination = summary.getAttribute('data-href');
        if (destination) window.location.assign(destination);
        return;
      }

      openDesktopMenu(state, part, event.detail === 0 ? 'keyboard' : 'pointer');
    });

    bindDesktopMenuEvent(state, document, 'keydown', function (event) {
      if (event.key !== 'Escape' || !state.activePart) return;

      event.preventDefault();
      closeDesktopMenu(state, {
        immediate: true,
        input: 'keyboard',
        restoreFocus: true,
      });
    });

    bindDesktopMenuEvent(state, document, 'click', function (event) {
      if (!state.activePart || navigation.contains(event.target)) return;
      closeDesktopMenu(state);
    });

    bindDesktopMenuEvent(state, document, 'focusin', function (event) {
      if (!state.activePart || state.activePart.details.contains(event.target)) return;

      closeDesktopMenu(state, {
        immediate: true,
        input: 'keyboard',
      });
    });

    return state;
  }

  function unloadDesktopMenuState(state) {
    if (!state) return;

    closeDesktopMenu(state, { immediate: true });
    state.parts.forEach(clearDesktopPanelTransition);
    state.events.forEach(function (event) {
      event.target.removeEventListener(
        event.eventName,
        event.listener,
        event.options
      );
    });
    state.events = [];
    desktopMenuStates.delete(state.navigation);
  }

  function pruneDesktopMenuStates() {
    desktopMenuStateList = desktopMenuStateList.filter(function (state) {
      if (state.navigation.isConnected) return true;
      unloadDesktopMenuState(state);
      return false;
    });
  }

  function unloadDesktopMenuStatesWithin(root) {
    desktopMenuStateList = desktopMenuStateList.filter(function (state) {
      var belongsToRoot = root && (
        root === state.navigation ||
        (typeof root.contains === 'function' && root.contains(state.navigation))
      );

      if (!belongsToRoot) return true;
      unloadDesktopMenuState(state);
      return false;
    });
  }

  function bindNavigation() {
    pruneDesktopMenuStates();

    document.querySelectorAll('[data-site-navigation]').forEach(function (navigation) {
      var existingState = desktopMenuStates.get(navigation);
      var designMode = !!(window.Shopify && window.Shopify.designMode);

      if (designMode) {
        navigation.setAttribute('data-excel-menu-controller', 'empire');
        return;
      }

      if (existingState) {
        if (!desktopLayoutQuery.matches) {
          closeDesktopMenu(existingState, { immediate: true });
        }
        return;
      }

      var state = createDesktopMenuState(navigation);
      if (!state) return;

      desktopMenuStates.set(navigation, state);
      desktopMenuStateList.push(state);
    });
  }

  function activateMegaPanel(menu, activeIndex, shouldFocus) {
    var tabs = Array.prototype.slice.call(
      menu.querySelectorAll('[data-excel-meganav-tab]')
    );
    var panels = Array.prototype.slice.call(
      menu.querySelectorAll('[data-excel-meganav-panel]')
    );

    if (!tabs.length || !panels.length) return;

    activeIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));

    tabs.forEach(function (tab, index) {
      var isActive = index === activeIndex;

      tab.classList.toggle('is-active', isActive);
      if (isActive) {
        tab.setAttribute('aria-current', 'true');
      } else {
        tab.removeAttribute('aria-current');
      }
    });

    panels.forEach(function (panel, index) {
      var isActive = index === activeIndex;

      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    if (shouldFocus) tabs[activeIndex].focus();
  }

  function bindMegaMenus() {
    document.querySelectorAll('[data-excel-meganav]').forEach(function (menu) {
      if (boundMegaMenus.has(menu)) return;

      var tabs = Array.prototype.slice.call(
        menu.querySelectorAll('[data-excel-meganav-tab]')
      );

      if (!tabs.length) return;

      boundMegaMenus.add(menu);
      activateMegaPanel(menu, 0, false);

      tabs.forEach(function (tab, index) {
        tab.addEventListener('pointerenter', function (event) {
          if (!desktopHoverQuery.matches) return;
          if (event.pointerType && event.pointerType !== 'mouse') return;
          activateMegaPanel(menu, index, false);
        });

        tab.addEventListener('focus', function () {
          activateMegaPanel(menu, index, false);
        });

        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;

          if (event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index && event.key !== 'Home' && event.key !== 'End') return;

          event.preventDefault();
          activateMegaPanel(menu, nextIndex, true);
        });
      });
    });
  }

  function mobilePanels(nav) {
    return Array.prototype.slice.call(
      nav.querySelectorAll('[data-excel-mobile-level]')
    );
  }

  function panelByLevel(nav, value) {
    return mobilePanels(nav).find(function (panel) {
      return panel.getAttribute('data-excel-mobile-level') === value;
    }) || null;
  }

  function mobilePanelScroller(panel) {
    return panel ? panel.querySelector('[data-excel-mobile-scroll]') : null;
  }

  function focusMobileControl(element) {
    if (!element) return;

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function clearMobilePanelTransition(panel) {
    if (panel && panel.excelMobileTransitionCleanup) {
      panel.excelMobileTransitionCleanup();
    }
  }

  function afterMobilePanelTransition(panel, callback) {
    if (!panel) {
      callback();
      return;
    }

    clearMobilePanelTransition(panel);

    var finished = false;
    var fallbackTimer = null;
    var transitionHandler = function (event) {
      if (event && (event.target !== panel || event.propertyName !== 'transform')) return;
      finish();
    };
    var cleanup = function () {
      panel.removeEventListener('transitionend', transitionHandler);
      if (fallbackTimer !== null) window.clearTimeout(fallbackTimer);
      fallbackTimer = null;
      panel.excelMobileTransitionCleanup = null;
    };
    var finish = function () {
      if (finished) return;
      finished = true;
      cleanup();
      callback();
    };

    panel.excelMobileTransitionCleanup = cleanup;
    panel.addEventListener('transitionend', transitionHandler);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.requestAnimationFrame(finish);
    } else {
      fallbackTimer = window.setTimeout(finish, mobilePanelTransitionFallback);
    }
  }

  function setMobilePanelAccessibility(panel, isActive) {
    if (!panel) return;

    panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    panel.toggleAttribute('inert', !isActive);
  }

  function resetMobileNavigation(state, restoreFocus) {
    if (!state || !state.root) return;

    mobilePanels(state.nav).forEach(function (panel) {
      clearMobilePanelTransition(panel);
      panel.classList.remove('is-active', 'is-behind', 'is-entering', 'is-exiting');

      var isRoot = panel === state.root;
      panel.hidden = !isRoot;
      panel.classList.toggle('is-active', isRoot);
      setMobilePanelAccessibility(panel, isRoot);

      var scroller = mobilePanelScroller(panel);
      if (scroller) scroller.scrollTop = 0;
    });

    state.nav.querySelectorAll(
      '[data-excel-mobile-drilldown-trigger], [data-excel-mobile-category-trigger]'
    ).forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });

    state.stack = [{ panel: state.root, trigger: null, scrollTop: 0 }];
    state.current = state.root;
    state.transitioning = false;

    var drilldowns = state.nav.querySelector('[data-excel-mobile-drilldowns]');
    if (drilldowns) drilldowns.scrollLeft = 0;

    if (restoreFocus && state.opener && state.opener.isConnected) {
      window.requestAnimationFrame(function () {
        focusMobileControl(state.opener);
      });
    }
  }

  function openMobileLevel(state, panel, trigger) {
    if (!state || !panel || state.transitioning || desktopLayoutQuery.matches) return;
    if (panel === state.current) return;

    var currentEntry = state.stack[state.stack.length - 1];
    var currentPanel = currentEntry.panel;
    var currentScroller = mobilePanelScroller(currentPanel);
    var nextScroller = mobilePanelScroller(panel);

    currentEntry.scrollTop = currentScroller ? currentScroller.scrollTop : 0;
    state.transitioning = true;

    clearMobilePanelTransition(currentPanel);
    clearMobilePanelTransition(panel);

    currentPanel.classList.remove('is-active', 'is-entering', 'is-exiting');
    currentPanel.classList.add('is-behind');
    setMobilePanelAccessibility(currentPanel, false);

    panel.hidden = false;
    panel.classList.remove('is-active', 'is-behind', 'is-exiting');
    panel.classList.add('is-entering');
    setMobilePanelAccessibility(panel, true);
    if (nextScroller) nextScroller.scrollTop = 0;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    state.stack.push({ panel: panel, trigger: trigger, scrollTop: 0 });
    state.current = panel;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        panel.classList.remove('is-entering');
        panel.classList.add('is-active');

        afterMobilePanelTransition(panel, function () {
          state.transitioning = false;
          var backButton = panel.querySelector('[data-excel-mobile-back]');
          focusMobileControl(backButton);
        });
      });
    });
  }

  function closeMobileLevel(state) {
    if (!state || state.transitioning || state.stack.length < 2) return;

    var currentEntry = state.stack[state.stack.length - 1];
    var parentEntry = state.stack[state.stack.length - 2];
    var currentPanel = currentEntry.panel;
    var parentPanel = parentEntry.panel;
    var parentScroller = mobilePanelScroller(parentPanel);

    state.transitioning = true;
    clearMobilePanelTransition(currentPanel);
    clearMobilePanelTransition(parentPanel);

    parentPanel.hidden = false;
    parentPanel.classList.remove('is-behind', 'is-entering', 'is-exiting');
    parentPanel.classList.add('is-active');
    setMobilePanelAccessibility(parentPanel, true);
    if (parentScroller) parentScroller.scrollTop = parentEntry.scrollTop || 0;

    currentPanel.classList.remove('is-active', 'is-entering', 'is-behind');
    currentPanel.classList.add('is-exiting');
    setMobilePanelAccessibility(currentPanel, false);
    if (currentEntry.trigger) currentEntry.trigger.setAttribute('aria-expanded', 'false');

    state.stack.pop();
    state.current = parentPanel;

    afterMobilePanelTransition(currentPanel, function () {
      currentPanel.hidden = true;
      currentPanel.classList.remove('is-exiting');
      state.transitioning = false;

      if (currentEntry.trigger && currentEntry.trigger.isConnected) {
        focusMobileControl(currentEntry.trigger);
      }
    });
  }

  function closeMobileDrawer(state) {
    var nativeClose = state.root.querySelector('[data-mobile-nav-close]');
    if (nativeClose) nativeClose.click();
  }

  function handleMobileDrawerState(state) {
    var drawer = state.nav.querySelector('[data-mobile-nav-panel]');
    if (!drawer) return;

    var animationState = drawer.getAttribute('data-animation-state');
    var isOpen = animationState === 'open';
    var isClosed = animationState === 'closed';

    if (isOpen && !state.isOpen) {
      state.isOpen = true;
      state.opener = document.querySelector('[data-menu-toggle]');
      state.nav.removeAttribute('inert');
      state.nav.setAttribute('aria-hidden', 'false');

      window.requestAnimationFrame(function () {
        var firstItem = state.root.querySelector(
          '[data-excel-mobile-drilldown-trigger], .mobile-nav-content a[href]'
        );
        focusMobileControl(firstItem);
      });
    }

    if (isClosed && state.isOpen) {
      state.isOpen = false;
      resetMobileNavigation(state, true);
      state.nav.setAttribute('aria-hidden', 'true');
      state.nav.setAttribute('inert', '');
    }
  }

  function createMobileNavState(nav) {
    var root = nav.querySelector('[data-excel-mobile-root-panel]');
    var state = {
      nav: nav,
      root: root,
      current: root,
      stack: [],
      opener: document.querySelector('[data-menu-toggle]'),
      isOpen: false,
      transitioning: false,
      observer: null,
    };

    resetMobileNavigation(state, false);
    nav.setAttribute('aria-hidden', 'true');
    nav.setAttribute('inert', '');

    var drawer = nav.querySelector('[data-mobile-nav-panel]');
    if (drawer) {
      state.observer = new MutationObserver(function () {
        handleMobileDrawerState(state);
      });
      state.observer.observe(drawer, {
        attributes: true,
        attributeFilter: ['data-animation-state'],
      });
      handleMobileDrawerState(state);
    }

    return state;
  }

  function bindMobileDrilldowns() {
    document.querySelectorAll('[data-mobile-nav]').forEach(function (nav) {
      var existingState = mobileNavStates.get(nav);

      if (desktopLayoutQuery.matches && existingState) {
        resetMobileNavigation(existingState, false);
      }

      if (boundMobileNavs.has(nav)) return;

      var state = createMobileNavState(nav);
      if (!state.root) return;

      boundMobileNavs.add(nav);
      mobileNavStates.set(nav, state);

      nav.addEventListener('click', function (event) {
        if (desktopLayoutQuery.matches) return;

        var rootTrigger = event.target.closest('[data-excel-mobile-drilldown-trigger]');
        var categoryTrigger = event.target.closest('[data-excel-mobile-category-trigger]');
        var backTrigger = event.target.closest('[data-excel-mobile-back]');

        if (rootTrigger && nav.contains(rootTrigger)) {
          var rootPanel = panelByLevel(
            nav,
            rootTrigger.getAttribute('data-excel-mobile-drilldown-trigger')
          );

          if (rootPanel) {
            event.preventDefault();
            event.stopPropagation();
            openMobileLevel(state, rootPanel, rootTrigger);
          }
          return;
        }

        if (categoryTrigger && nav.contains(categoryTrigger)) {
          var categoryPanel = panelByLevel(
            nav,
            categoryTrigger.getAttribute('data-excel-mobile-category-trigger')
          );

          if (categoryPanel) {
            event.preventDefault();
            event.stopPropagation();
            openMobileLevel(state, categoryPanel, categoryTrigger);
          }
          return;
        }

        if (backTrigger && nav.contains(backTrigger)) {
          event.preventDefault();
          event.stopPropagation();
          closeMobileLevel(state);
          return;
        }

        var closeTrigger = event.target.closest('[data-mobile-nav-close]');

        if (closeTrigger && !state.root.contains(closeTrigger)) {
          event.preventDefault();
          event.stopPropagation();
          closeMobileDrawer(state);
        }
      }, true);

      nav.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || desktopLayoutQuery.matches) return;

        event.preventDefault();
        event.stopPropagation();
        closeMobileDrawer(state);
      }, true);
    });
  }

  function scheduleBind() {
    window.requestAnimationFrame(function () {
      bindNavigation();
      bindMegaMenus();
      bindMobileDrilldowns();
      bindTrustRotation();
      updateStickyHeader(true);
    });
  }

  function getStickyHeader() {
    var header = document.querySelector('[data-site-header]');
    return header || null;
  }

  function updateHeaderHeight(header) {
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  function activateTrustItem(items, activeIndex) {
    items.forEach(function (item, index) {
      var isActive = index === activeIndex;

      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  function bindTrustRotation() {
    var header = getStickyHeader();
    if (!header) return;

    var trustBar = header.querySelector('[data-excel-trust-bar]');
    if (!trustBar) return;

    var items = Array.prototype.slice.call(
      trustBar.querySelectorAll('[data-excel-trust-item]')
    );

    if (trustBar.excelTrustTimer) {
      window.clearInterval(trustBar.excelTrustTimer);
      trustBar.excelTrustTimer = null;
    }

    if (desktopLayoutQuery.matches || items.length < 2) {
      items.forEach(function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-hidden', 'false');
      });
      return;
    }

    var activeIndex = items.findIndex(function (item) {
      return item.classList.contains('is-active');
    });

    trustBar.excelTrustIndex = activeIndex >= 0 ? activeIndex : 0;
    activateTrustItem(items, trustBar.excelTrustIndex);

    trustBar.excelTrustTimer = window.setInterval(function () {
      if (document.hidden || trustBar.matches(':hover') || trustBar.contains(document.activeElement)) {
        return;
      }

      trustBar.excelTrustIndex = (trustBar.excelTrustIndex + 1) % items.length;
      activateTrustItem(items, trustBar.excelTrustIndex);
    }, trustRotationDelay);
  }

  function setCondensed(header, shouldCondense) {
    if (header.classList.contains(condensedClass) === shouldCondense) return;

    var nav = header.querySelector('[data-site-navigation]');
    var trustBar = header.querySelector('[data-excel-trust-bar]');

    header.classList.toggle(condensedClass, shouldCondense);

    [nav, trustBar].forEach(function (element) {
      if (!element) return;

      element.toggleAttribute('inert', shouldCondense);
      element.setAttribute('aria-hidden', shouldCondense ? 'true' : 'false');
    });

    if (shouldCondense) {
      var desktopState = nav ? desktopMenuStates.get(nav) : null;
      if (desktopState) closeDesktopMenu(desktopState, { immediate: true });

      header.querySelectorAll('[data-site-navigation] details[open]').forEach(function (details) {
        details.removeAttribute('open');
      });
    }
  }

  function setMobileTrustHidden(header, shouldHide) {
    if (header.classList.contains(mobileScrolledClass) === shouldHide) return;

    var trustBar = header.querySelector('[data-excel-trust-bar]');

    header.classList.toggle(mobileScrolledClass, shouldHide);

    if (trustBar) {
      trustBar.toggleAttribute('inert', shouldHide);
      trustBar.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
    }
  }

  function updateStickyHeader(forceHeightUpdate) {
    stickyFrame = null;

    var header = getStickyHeader();
    if (!header) return;

    var stickyEnabled = header.getAttribute('data-excel-sticky-header') === 'true';
    document.body.classList.toggle('site-header-sticky', stickyEnabled);

    if (!stickyEnabled) {
      setCondensed(header, false);
      setMobileTrustHidden(header, false);
      if (forceHeightUpdate) updateHeaderHeight(header);
      return;
    }

    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (!desktopLayoutQuery.matches) {
      var mobileTrustIsHidden = header.classList.contains(mobileScrolledClass);

      setCondensed(header, false);

      if (!mobileTrustIsHidden && scrollY >= mobileCollapseThreshold) {
        setMobileTrustHidden(header, true);
      } else if (mobileTrustIsHidden && scrollY <= mobileExpandThreshold) {
        setMobileTrustHidden(header, false);
      }

      if (forceHeightUpdate) updateHeaderHeight(header);
      return;
    }

    setMobileTrustHidden(header, false);

    var isCondensed = header.classList.contains(condensedClass);

    if (!isCondensed && scrollY >= collapseThreshold) {
      setCondensed(header, true);
    } else if (isCondensed && scrollY <= expandThreshold) {
      setCondensed(header, false);
    }

    if (forceHeightUpdate) updateHeaderHeight(header);
  }

  function scheduleStickyUpdate() {
    if (stickyFrame !== null) return;

    stickyFrame = window.requestAnimationFrame(function () {
      updateStickyHeader(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleBind, { once: true });
  } else {
    scheduleBind();
  }

  document.addEventListener('shopify:section:load', scheduleBind);
  document.addEventListener('shopify:section:unload', function (event) {
    unloadDesktopMenuStatesWithin(event.target);
  });
  window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
  window.addEventListener('resize', scheduleBind);

  if (desktopHoverQuery.addEventListener) {
    desktopHoverQuery.addEventListener('change', scheduleBind);
  } else if (desktopHoverQuery.addListener) {
    desktopHoverQuery.addListener(scheduleBind);
  }

  if (desktopLayoutQuery.addEventListener) {
    desktopLayoutQuery.addEventListener('change', scheduleBind);
  } else if (desktopLayoutQuery.addListener) {
    desktopLayoutQuery.addListener(scheduleBind);
  }
})();
